import { render, staticRenderFns } from "./login.vue?vue&type=template&id=52fc7a06"
import script from "./login.vue?vue&type=script&lang=js"
export * from "./login.vue?vue&type=script&lang=js"
import style0 from "./login.vue?vue&type=style&index=0&id=52fc7a06&prod&lang=css"
import style1 from "./login.vue?vue&type=style&index=1&id=52fc7a06&prod&scope=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports